import { useState } from 'react';
import { Button } from '../../components/ui/Button';
import { useSettingsContext } from '../../components/settings';
import { CheckEnvironment, SupportedEnvironments } from '../../config-global';

export interface CrashableChildProps {
  unused?: boolean[];
}

export default function CrashableChild({ unused }: CrashableChildProps) {
  const { themeStretch } = useSettingsContext();

  const [devJSXCrashEnabled, setDevJSXCrashEnabled] = useState(false);

  const onTestAButtonClick = () => {
    console.log('test A button clicked');

    setDevJSXCrashEnabled(true);
  };

  if (!CheckEnvironment(SupportedEnvironments.Dev)) {
    // failsafe, this doesn't have a prod usage
    return null;
  }

  return (
    <div className={`mx-auto m-5 ${themeStretch ? 'max-w-3xl' : 'max-w-5xl'}`}>
      <Button loading={false} variant="outline" onClick={onTestAButtonClick}>
        Trigger Error in Child Component
      </Button>

      {devJSXCrashEnabled && (
        <>
          {
            //FORCE THIS: "TypeError: g.map is not a function"
            // brokenObject.map((v: any) => { return (<div>{v}</div>); }) // intentional bad invoke

            //FORCE THIS: "TypeError: ??"
            (unused as any).map((v: any) => {
              return <div>{v}</div>;
            }) // intentional bad invoke
          }
        </>
      )}
    </div>
  );
}
